import React from 'react';
import {
    withRouter
  } from 'react-router-dom'

/* Design assets */
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button/Button';
import LockOpen from '@material-ui/icons/LockOpen';
import List from '@material-ui/icons/List';
import BorderVertical from '@material-ui/icons/BorderVertical';
import Home from '@material-ui/icons/Home';

const styles = theme => ({
    
    button: {
      backgroundColor: '#3ab9c5',
      border: '1px solid black',
      fontSize: 12,
      width: 200,    
    },
    stickyFooter:{
      paddingTop: "1vh",
      paddingBottom: "1vh",
      width: 150,
      marginLeft:80,
      marginRight: 80,
      marginBottom: 0,
      marginTop: 0,
      lineHeight: 3
    },
    buttonIcons: {
      width: 15,
      paddingRight: 12,
      textAlign: "left",
      display: "block",
      lineHeight: "unset !important"
    },
    buttonText: {
      margin: 0,
      padding: 0,
      width: 135,
      textAlign: "left"
    }
  });


const ConsoleLog = ({ children }) => {
    console.log(children);
    return false;
    };

const Footer = ({ children }) => {
return (
        <div>
            <div>{children}</div>
        </div>
    );
}

class ButtonAppBarFooter extends React.Component {    
    scanCode = (props) => {        
        this.props.history.push('/CodeScan');
    };
    openCloseCodes = (props) => {        
        this.props.history.push('/OpenCloseCodes');
    };
    tempCode = (props) => {  
        this.props.history.push('/TempCodeRqst');
    };
    home = (props) => {  
        this.props.history.push('/');
    };

    render(){
    const { classes } = this.props; 

    

/* ======================================================================================== */
  return (
        <div className={classes.stickyFooter}>        
        
        <React.Fragment>           
            <Footer>
            {this.props.location.pathname !== "/" &&
                <span>
                    <Button className={classes.button}   
                        type="button"  
                        onClick={this.home}>
                        <span className={classes.buttonIcons} ><Home /></span><span className={classes.buttonText}>Home</span>
                    </Button>
                </span>
                }  
                {this.props.location.pathname !== "/CodeScan" &&
                <span>                  
                    <Button className={classes.button}   
                        type="button"  
                        onClick={this.scanCode}>
                        <span className={classes.buttonIcons} ><BorderVertical /> </span><span className={classes.buttonText}>QR CODE SCAN</span>
                    </Button>
                </span>
                }
                {this.props.location.pathname !== "/TempCodeRqst" &&
                <span>
                <Button className={classes.button}   
                        type="button"  
                        onClick={this.tempCode}>
                            <span className={classes.buttonIcons}><LockOpen /></span><span className={classes.buttonText}>TEMP CODE</span>
                    </Button>
                </span>
                }
                {this.props.location.pathname !== "/OpenCloseCodes" &&
                <span>
                    <Button className={classes.button}   
                        type="button"  
                        onClick={this.openCloseCodes}>
                        <span className={classes.buttonIcons} ><List /></span><span className={classes.buttonText}>OPEN/CLOSE CODES</span>
                    </Button>
                </span>
                }                                
            </Footer>
        </React.Fragment>
        </div>
  );
 } 
}export default withRouter((withStyles(styles)(ButtonAppBarFooter)))


// WEBPACK FOOTER //
// ./src/components/ButtonAppBarFooter.jsx